export default __webpack_public_path__ + "static/media/not-found.c4ba1e76.png";